// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-info-__slug-indexstyleGrid-container-bqlfm{margin:0 auto;max-width:1536px;padding:0 24px;width:100%}.pages-info-__slug-indexstyleGrid-grid-todts{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-info-__slug-indexstyleGrid-col6-bmsxz{grid-column:span 6}.pages-info-__slug-indexstyleGrid-col3-itrqc{grid-column:span 3}.pages-info-__slug-indexstyleGrid-col4-buoys{grid-column:span 4}.pages-info-__slug-indexstyleGrid-col9-umazh{grid-column:span 9}.pages-info-__slug-indexstyleGrid-col12-bplum{grid-column:span 12}.pages-info-__slug-indexstyleGrid-alignItemsStart-jwnyx{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-info-__slug-indexstyleGrid-container-bqlfm",
	"grid": "pages-info-__slug-indexstyleGrid-grid-todts",
	"col6": "pages-info-__slug-indexstyleGrid-col6-bmsxz",
	"col3": "pages-info-__slug-indexstyleGrid-col3-itrqc",
	"col4": "pages-info-__slug-indexstyleGrid-col4-buoys",
	"col9": "pages-info-__slug-indexstyleGrid-col9-umazh",
	"col12": "pages-info-__slug-indexstyleGrid-col12-bplum",
	"alignItemsStart": "pages-info-__slug-indexstyleGrid-alignItemsStart-jwnyx"
};
module.exports = ___CSS_LOADER_EXPORT___;
